import { useNavigate } from "react-router-dom";
import Add from "../../table/Add"
import { useForm } from "react-hook-form";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { distributaryZone } from "../../../constants";

const GroupAdd =() =>{

    const navigate = useNavigate();
   
    const onSubmit = async (data: any) => {
      try {
         
        const groupData = {
          GroupName: data.GroupName,
          DeviceType: data.DeviceType
        }

        const response = await ApiService.axiosApi('/groupnamemaster', {
          method: 'POST',
          data:groupData
        });
  
        if (response.success) {
          toast.success("Group added successfully");
          navigate(-1);
        } else {
          toast.error(response.data.message || "Failed to add distributary");
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to add distributary");
      }
    };
  

    return(
        <>
          <Add
       title={'Add Group'}
       parentTitle = {'Group'}
       onSubmit = {onSubmit}
       fields = {[
        {
          name : "GroupName",
          label : "Group",
          type: "text",
          validation :  { required: "Group is required" }
        },
        {
          name : "DeviceType",
          label : "Device Type",
          type: "text",
          validation :  { required: "Type is required" }
        },
       
       ]}
     />
         
        </>
    )
}

export default GroupAdd;